import React, { useState, useEffect } from "react";

const LiveClock = () => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const formatted = now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      });
      setTime(formatted);
    };

    updateClock(); // run immediately once
    const interval = setInterval(updateClock, 1000);

    return () => clearInterval(interval); // cleanup
  }, []);

  return <h2>🕒 {time}</h2>;
};

export default LiveClock;